import { Helmet } from 'react-helmet-async';

const SEOHead = () => {
  const siteUrl = 'https://hugorenzi.com.br';
  const canonicalUrl = `${siteUrl}/`;
  const ogImage = `${siteUrl}/og-image.png`;
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>Hugo Renzi | Landing Pages Profissionais</title>
      <meta 
        name="description" 
        content="Crie sua landing page profissional por R$147/mês. Site responsivo, otimizado para conversão e integrado com WhatsApp. Sem custo inicial." 
      />
      <meta 
        name="keywords" 
        content="criação de sites, landing page profissional, site para pequenos negócios, criação de site mensal, site por assinatura, desenvolvimento web, site responsivo, landing page conversão" 
      />
      <meta name="author" content="Hugo Renzi" />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content="Hugo Renzi | Landing Pages Profissionais" />
      <meta 
        property="og:description" 
        content="Crie sua landing page profissional por R$147/mês. Site responsivo, otimizado para conversão e integrado com WhatsApp. Sem custo inicial." 
      />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="Hugo Renzi - Landing Pages" />
      <meta property="og:locale" content="pt_BR" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content="Hugo Renzi | Landing Pages Profissionais" />
      <meta 
        name="twitter:description" 
        content="Crie sua landing page profissional por R$147/mês. Site responsivo, otimizado para conversão e integrado com WhatsApp. Sem custo inicial." 
      />
      <meta name="twitter:image" content={ogImage} />

      {/* Additional Meta Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=5" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="language" content="Portuguese" />
      <meta name="revisit-after" content="7 days" />

      {/* Structured Data - Schema.org */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ProfessionalService",
          "name": "Hugo Renzi - Landing Pages Profissionais",
          "description": "Criação de landing pages profissionais por assinatura para pequenos negócios",
          "url": siteUrl,
          "telephone": "+55-21-99999-9999",
          "priceRange": "R$147 - R$297",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Curitiba",
            "addressRegion": "PR",
            "addressCountry": "BR"
          },
          "offers": [
            {
              "@type": "Offer",
              "name": "Plano Essencial",
              "price": "147",
              "priceCurrency": "BRL",
              "description": "Landing page profissional com hospedagem e suporte básico"
            },
            {
              "@type": "Offer",
              "name": "Plano Profissional",
              "price": "197",
              "priceCurrency": "BRL",
              "description": "Plano completo com SEO avançado e formulário integrado"
            }
          ]
        })}
      </script>
    </Helmet>
  );
};

export default SEOHead;
